import axios from "axios";
import { trackRequestStart, trackRequestEnd } from "@/lib/loadProgress";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const API_BASE = API;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer as fallback (some browsers reject 3rd-party cookies)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("orbit_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.request.use((config) => { trackRequestStart(); return config; });
api.interceptors.response.use(
  (res) => { trackRequestEnd(); return res; },
  (err) => { trackRequestEnd(); return Promise.reject(err); },
);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
